/**
 * Video Chooser
 *
 * Used for selecting a youtube video for fields in storm.
 *
 * @author dbapat@yext.com
 */
goog.provide('yext.videochooser');

goog.require('goog.string');

goog.require('yext');
goog.require('yext.ajax');
goog.require('yext.dam.assetselector.video');
goog.require('yext.youtube');
goog.require('yext.utils.youtube');

/** @type {function(Node)} */
yext.videochooser.enableSubmit = undefined;

/**
 * Initialize the video chooser package for selecting youtube videos
 * @param inputName        The name of the input element used for storing video name
 * @param enableSubmitFunc The function used to enable the submit function
 * @param onFieldSaveFunc  The function used to handle when the storm field is saved
 */
yext.videochooser.init = function(inputName, enableSubmitFunc, onFieldSaveFunc) {
  yext.videochooser.videoInputNameSelector = '[name="' + inputName + '"]';
  yext.videochooser.bindHandlers();
  yext.videochooser.enableSubmit = function(formEl) {
    var $formEl = $(formEl);
    $formEl.find('.submit').removeClass('disabled');
    $formEl.closest('form').data('changed', true);
  };
  if (yext.isFunction(enableSubmitFunc)) {
    yext.videochooser.enableSubmit = enableSubmitFunc;
  }
  if (yext.isFunction(onFieldSaveFunc)) {
    yext.videochooser.onFieldSave = onFieldSaveFunc;
  }
};

/**
 * Bind the link to open a video search, select a video and remove a video
 */
yext.videochooser.bindHandlers = function() {
  yext.videochooser.bindSearchVideo();
  yext.videochooser.bindSelectVideo();

  $('.js-remove-video-item')
    .off('click.videoChooser')
    .on('click.videoChooser', function() {
      yext.videochooser.clearVideo(this);
    });
};

/**
 * Bind the class that selects a video from the video search
 */
yext.videochooser.bindSelectVideo = function() {
  $('.js-search-video .js-select-video-button')
    .off('click.videoChooser')
    .on('click.videoChooser', function() {
      yext.videochooser.selectVideo(this);
    });
};

/**
 * Update the preview screen with the thumbnail and details given the value stored in the
 * hidden video cache
 * @param el     The input element used to determing the video
 * @param isLoad is the video already loaded? Then grab the value from the cache
 */
yext.videochooser.updateVideoPreview = function(el, isLoad) {
  var $el = $(el);
  var value = $.trim($el.val());
  if (isLoad && !value.length) {
    value = $el.parent().siblings('input[name="video-cache"]').val();
    $el.closest('.video-search-url-input .js-video-url-input').val(value);
  }
  yext.dam.assetselector.video.updatePreview(value);
};
goog.exportSymbol('yext.videochooser.updateVideoPreview', yext.videochooser.updateVideoPreview);

/**
 * Clear a video
 * @param el The element with the youtube element input
 */
yext.videochooser.clearVideo = function(el) {
  var form = $(el).parents('form');
  form.find(yext.videochooser.videoInputNameSelector)
    .val('')
    .each(function(i, el) {
      yext.videochooser.updateVideoPreview(el);
    });
  form.find('[name="video.description"]')
    .val('')
    .removeAttr('placeholder');
  yext.videochooser.enableSubmit(form[0]);
};

/**
 * When a thumbnail is clicked, open a dialog to play the video
 * @this {HTMLElement}
 * @param evt The event of clicking on the thumbnail
 * TODO(nliang): remove this function
 */
yext.videochooser.onVideoThumbnailClick = function(evt) {
  evt.stopPropagation();

  var $this = $(this);
  var ytid = $this.data('ytid');
  var template = $('.js-video-play-template').html();
  var html = template.replace(/{{=ytid}}/g, goog.string.htmlEscape(ytid));
  $('<div/>').html(html).dialog({
    modal: true,
    draggable: false,
    resizable: false,
    height: 450,
    width: 665,
    close: function(event, ui) {
      $(this).remove();
    },
  });
};

/**
 * Open up the dialog to search for a youtube video
 */
yext.videochooser.bindSearchVideo = function() {
  $('.video-search .submit')
    .off('click')
    .on('click', function() {
      yext.videochooser.searchForVideo($(this).parent('form'));
    });
};

/**
 * From a set of videos, populate the youtube template and append to results
 * @param videos The videos to append to the page
 * @param results The container for appending the video info
 */
yext.videochooser.onGetDetailsSuccess = function(videos, results) {
  var template = $('.video-search-result-template').html();
  $.each(videos, function(i, video) {
    var html = yext.utils.youtube.fixupVideoTemplate(template, video);
    results.append($('<div/>').html(html));
  });
  yext.videochooser.bindSelectVideo();
};

/**
 * Actually search for the youtube video given the search paramter
 * @param form The form for searching the video
 */
yext.videochooser.searchForVideo = function(form) {
  form = $(form);
  var $video = form.closest('.video-search');
  var $results = $video.find('.video-search-results');
  var searchTerm = form.find('input[name="video.search"]').val();

  var onError = function() {
    // TRANSLATORS: Indicates there was an issue with a YouTube video search
    $results.html(yext.msgc('youtube', 'There was a problem loading your search results.'));
  };

  $.ajax({
    url: 'https://www.googleapis.com/youtube/v3/search' +
          '?key=AIzaSyDPbj7wOaE0F3ZhSMYtQjo-dW0sCG67YpU' +
          '&part=snippet' +
          '&fields=items(id(videoId))' +
          '&maxResults=10'+
          '&q=' + encodeURIComponent(searchTerm),
    dataType: 'jsonp',
    timeout: 10000,
    success: function(data) {
      try {
        if (!data.items || !data.items.length) {
          // TRANSLATORS: Indicates there were no results for a YouTube video search
          $results.html(yext.msgc('youtube', 'No results found.'));
          return;
        }
        $results.empty();

        var ids = [];
        $.each(data.items, function(i, item) {
          ids.push(item.id.videoId);
        });

        yext.youtube.getVideosDetails(
          ids,
          function(videos) {
            yext.videochooser.onGetDetailsSuccess(videos, $results);
          },
          undefined);
      } catch (e) {
        onError();
      }
    },
    error: yext.ajax.errorWrapper(onError),
  });
};
goog.exportSymbol('yext.videochooser.searchForVideo', yext.videochooser.searchForVideo);

/**
 * Select a video from the search results
 * @param el The selection that was selected
 */
yext.videochooser.selectVideo = function(el) {
  var $el = $(el);
  var ytid = $el.data('ytid');

  $('.video-search .js-select-video-button').removeClass('disabled');
  $el.addClass('disabled');

  // NOTE(eefi): This breaks if there are multiple video selects on a page.
  $(yext.videochooser.videoInputNameSelector)
    .val('http://www.youtube.com/watch?v=' + ytid)
    .each(function(i, el) {
      yext.videochooser.updateVideoPreview(el);
      yext.videochooser.enableSubmit(el.form);
    });
};

/**
 * On video save, validate the url and repopulate the video display
 * @param $form The form to save the field
 */
yext.videochooser.validateVideoUrl = function($form) {
  var value = $.trim($form.find(yext.videochooser.videoInputNameSelector).val());

  if (value && window.doClientValidation) {
    if (!yext.youtube.validUrl(value)) {
      $form.find('.field-edit-form-errors').text(
        yext.msg('The URL you entered is not a valid YouTube video URL.')).show();
      return false;
    }
  }
  return true;
};

// TODO(jeff) switch to onFieldSave
/**
 * Handler for when the the video gets saved
 * @param form form that will be saved
 */
yext.videochooser.onVideoSave = function(form) {
  var $form = $(form);

  yext.videochooser.validateVideoUrl($form);

  $form.parents('td').find('.validation-error').removeClass('validation-error');
  if (yext.videochooser.onFieldSave && yext.isFunction(yext.videochooser.onFieldSave)) {
    yext.videochooser.onFieldSave(form, $form.serialize(), function($td, data) {
      $td.each(function(i, el) {
        yext.videochooser.loadVideoDisplays(el);
      });
    });
  }
};

/**
 * Given an element, load the video display from the data in the element
 * @param el element referring to the youtube input template
 * @return {boolean} if item has a video display
 */
yext.videochooser.loadVideoDisplays = function(el) {
  var videoSet = true;
  $(el).find('.js-video-display-url').each(function(i, urlEl) {
    var $urlEl = $(urlEl);
    var url = $.trim($urlEl.text());
    var ytid = url.replace(/^.*v=/, '');
    var onError = function() {
      var aTag = '<a href="' + url + '">' + url + '</a>';
      $urlEl.siblings('.js-video-display')
      // TRANSLATORS: The argument is a link
        .html(yext.msg('Could not load video details for {0}', aTag));
    };

    // Assume the item has no video yet if the URL does not exist or is empty string.
    if (!url || url.length === 0) {
      videoSet = false;
      return;
    }

    yext.youtube.getVideosDetails([ytid], function(videos) {
      try {
        var video = videos[0];
        if (video.id !== ytid) {
          throw new Error();
        }
        var template = $('.js-video-display-template').html();
        var html = yext.utils.youtube.fixupVideoTemplate(template, video);

        $urlEl.siblings('.js-video-display')
          .html(html)
          .find('a')
          .click(function(evt) {
            evt.stopPropagation();
          })
          .end()
          .find('img')
          .click(yext.videochooser.onVideoThumbnailClick);

        $(el).trigger('video.loaded');
      } catch (e) {
        onError();
      }
    }, yext.ajax.errorWrapper(onError));
  });

  return videoSet;
};
goog.exportSymbol('yext.videochooser.loadVideoDisplays', yext.videochooser.loadVideoDisplays);
